var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-y-reverse-transition',[_c('v-card',{staticClass:"primary elevation-10 posicao-card cor-card",attrs:{"dark":""}},[_c('v-card-text',[_c('h3',{staticClass:"headline"},[_c('b',[_vm._v("Breakpoint")]),_vm._v(": "+_vm._s(_vm.$vuetify.breakpoint.name))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }